import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { WalletSelectorBlock } from '@root/features/user/user-trading-analytics/ui/wallet-selector/wallet-selector-block'

import { StatisticsPriceTypeTabs } from './common/statistics-price-type-tabs'
import { ProfileBoardStatisticsPeriod } from './profile-board-statistics-period'

import type { UserTradingAnalyticsModel } from '@root/features/user/user-trading-analytics/atoms'

type Props = {
  model: UserTradingAnalyticsModel
}

export const ProfileBoardStatisticsHeader: React.FC<Props> = ({ model }) => {
  const [priceType, setPriceType] = useAtom(model.priceTypeAtom)

  return (
    <Root>
      <HeaderLeft>
        <ProfileBoardStatisticsPeriod model={model} />
        <StatisticsPriceTypeTabs
          priceType={priceType}
          onPriceTypeChange={setPriceType}
        />
      </HeaderLeft>
      <WalletSelectorBlock model={model} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 15px;
`

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`
